import React, { useMemo } from "react";
import TeX from "@matejmazur/react-katex";
import DOMPurify from "dompurify"; // For sanitizing the decoded HTML
import "katex/dist/katex.min.css"; // KaTeX styles
import he from "he"; // To decode HTML entities

const KatexText = ({ text }) => {
  const mathMarker = "@_m_@"; // Delimiter for KaTeX parts

  // Parse and format text, identifying the sections marked with KaTeX and HTML tags
  const elements = useMemo(() => {
    const parts = [];
    let lastIndex = 0;
    let index = text.indexOf(mathMarker, lastIndex);

    // Function to decode HTML entities and return sanitized HTML content
    const decodeAndSanitize = (str) => {
      const decodedStr = he.decode(str); // Decode HTML entities
      const sanitizedStr = DOMPurify.sanitize(decodedStr); // Sanitize the decoded HTML
      return sanitizedStr;
    };

    // Function to push text parts with decoded HTML content
    const pushTextWithHTML = (str) => {
      // Decode and sanitize the text part
      const sanitizedHTML = decodeAndSanitize(str);
      parts.push(
        <span
          key={lastIndex}
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      );
    };

    while (index !== -1) {
      if (index > lastIndex) {
        // Push non-math text parts, with HTML decoding and sanitization
        pushTextWithHTML(text.slice(lastIndex, index));
      }

      // Find the closing KaTeX marker
      let end = text.indexOf(mathMarker, index + mathMarker.length);
      if (end === -1) {
        end = text.length;
      }

      // Push the math expression wrapped in TeX
      const mathContent = text.slice(index + mathMarker.length, end);
      parts.push(<TeX key={index}>{mathContent}</TeX>);

      lastIndex = end + mathMarker.length;
      index = text.indexOf(mathMarker, lastIndex);
    }

    // Push the remaining non-math text after the last marker
    if (lastIndex < text.length) {
      pushTextWithHTML(text.slice(lastIndex));
    }

    return parts;
  }, [text]);

  return <>{elements}</>;
};

export default KatexText;
